import {Item} from "../types";
import {layout, typography} from "@variocube/cube-ui";
import * as React from "react";
import {useLocalization} from "../../i18n";

export interface ItemDetailProps {
    item?: Item;
    className?: string;
}

export function ItemDetail({item, className}: ItemDetailProps) {
    const {t} = useLocalization();
    return (
        <div className={className}>
            <div className={typography.title}>{t("Item")}</div>
            {item && (
                <div className={layout.marginYSmall}>
                    <div>{item.name}</div>
                    <div>{item.description}</div>
                    <div>{item.foreignId}</div>
                </div>
            )}
            {!item && (
                <div>
                    {t("NoItem")}
                </div>
            )}
        </div>
    )
}